import { Issue } from "./model";

export const getIssueStateText = (issue: Issue) => {
  if (issue.state === "closed") return "Closed";
  if (issue.labels.length === 0) return "No labels";
  return issue.labels.join(", ");
};
